import React from "react";
import { Box } from "@mui/material";
import SparklineContent from "./SparklineContent";
import withQueryWidget, { WithQueryWidgetProps } from "components/widgetParts/queryWidgetComposition/withQueryWidget";
import { getSingleOriginalRequestByName, getSingleResponseValue, getSingleWidgetResponseByName } from "system/widget/Widget";

function Sparkline(props: WithQueryWidgetProps): JSX.Element {
  const apiResponseInfo = getSingleWidgetResponseByName(props.apiResponses, 'sparkline');
  const originalRequest = getSingleOriginalRequestByName(props.activeWidgetRequests, 'sparkline');
  
  const valueResponse = getSingleWidgetResponseByName(props.apiResponses, "sparkline-value");
  const value = valueResponse ? getSingleResponseValue(valueResponse) : 0;

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <SparklineContent
        apiResponseBody={apiResponseInfo?.responseBody}
        apiRequestInfo={originalRequest}
        queryDisplayTitle={apiResponseInfo?.queryDisplayTitle}
        queryInfo = {props.queryInfo}
        widget = {props.widget}
        activeQueryIds = {apiResponseInfo?.originatingRequest?.activeQueryIds}
        value={value}
      />
    </Box>
  );
}

export default withQueryWidget(Sparkline, {
  hasSettingsDialog: true,
  hasQueryDialog: true
});
